import {Component, ElementRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {MultiImageChartConfigurations} from "../../charts/multi-image-chart/multi.image.chart.configurations";
import {KlaHttpService} from "../services/kla.http.service";
import {TitleConfigurations, TitleLineConfigurations} from "../title/title.configurations";
import { CommonModule } from '@angular/common';
import { MultiImageChartComponent } from 'app/shared/charts/multi-image-chart/multi-image-chart.component';
import { TitleComponent } from '../title/title.component';
import { SafeHtmlPipe } from '../safe-html/safe-html';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-multi-image',
  templateUrl: './multi-image.component.html',
  styleUrls: ['./multi-image.component.scss'],
  standalone: true,
  imports: [ CommonModule, MultiImageChartComponent, TitleComponent, DynamicContentComponent ]
})
export class MultiImageComponent implements OnInit {

  @Input()
  public lineConfig: TitleLineConfigurations;

  @Input()
  public titleConfig: TitleConfigurations;

  @Input()
  public chartId: string;

  @Input()
  public chartAltText: string;

  public config: MultiImageChartConfigurations;

  @ViewChild('panel', {static: true})
  public panel:ElementRef;

  constructor(private http: KlaHttpService) { }

  ngOnInit() {
    this.http.getChartData("kla-multi-image", this.chartId).subscribe(
      (data) => {
        this.config = data;
        if (!this.config) {
          console.error("Please provide multi image chart configurations");
        } else {
          this.resize();
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  @HostListener('window:resize')
  onResize() {
    if (this.config) {
      this.resize();
    }
  }

  private resize() {
    let rectangle = this.panel.nativeElement.getBoundingClientRect();
    let width = rectangle.width - 50;
    this.config.mode = width > 400 ? "web": "mobile";
    this.config.width = width;
    this.config.height = width > 400 ? null : this.config.items.length*150;
    this.config.visible = true;
    this.config = JSON.parse(JSON.stringify(this.config));
  }
}
